import { Action } from '@ngrx/store';
import { Type } from '@angular/core';

export enum ClientActionsTypes {
  LoadClients = '[Clients] Load clients',
  LoadClientsSuccess = '[Clients] Load clients success',
  LoadClientsFail = '[Clients] Load clients fail',

  LoadClientFormTemplates = '[Clients] Load Form Templates',
  LoadClientFormTemplatesSuccess = '[Clients] Load form femplates success',
  LoadClientFormTemplatesFail = '[Clients] Load form femplates fail',
}

export class LoadClients implements Action {
  readonly type = ClientActionsTypes.LoadClients;
}

export class LoadClientsSuccess implements Action {
  readonly type = ClientActionsTypes.LoadClientsSuccess;
  constructor(public payload: any) {}
}

export class LoadClientsFail implements Action {
  readonly type = ClientActionsTypes.LoadClientsFail;
  constructor(public payload: any) {}
}

export class LoadClientFormTemplates implements Action {
  readonly type = ClientActionsTypes.LoadClientFormTemplates;
}

export class LoadClientFormTemplatesSuccess implements Action {
  readonly type = ClientActionsTypes.LoadClientFormTemplatesSuccess;
  constructor(public payload: any) {}
}

export class LoadClientFormTemplatesFail implements Action {
  readonly type = ClientActionsTypes.LoadClientFormTemplatesFail;
  constructor(public payload: any) {}
}

export type ClientActions =
  | LoadClients
  | LoadClientsSuccess
  | LoadClientsFail
  | LoadClientFormTemplates
  | LoadClientFormTemplatesSuccess
  | LoadClientFormTemplatesFail;
